export const SLOT_COUNT = 12
export const WIDGET_IDS = Object.freeze(['exposure', 'breadth', 'ratio', 'credit', 'fomo'])
export const DEFAULT_LAYOUT = Object.freeze([{id:'exposure',slot:0,span:2},{id:'breadth',slot:3,span:2},{id:'ratio',slot:6,span:2},{id:'credit',slot:9,span:2},{id:'fomo',slot:11,span:1}])
const cells = item => Array.from({length:item.span},(_,i)=>item.slot+i)
const valid = item => WIDGET_IDS.includes(item?.id) && Number.isInteger(item.slot) && item.slot >= 0 && [1,2].includes(item.span) && item.slot+item.span <= SLOT_COUNT
export function normalizeWidgetLayout(value) {
  const used = new Set(), ids = new Set()
  return (Array.isArray(value) ? value : DEFAULT_LAYOUT).filter(item => {
    if (!valid(item) || ids.has(item.id) || cells(item).some(slot=>used.has(slot))) return false
    ids.add(item.id); cells(item).forEach(slot=>used.add(slot)); return true
  }).map(({id,slot,span})=>({id,slot,span}))
}
const fits = layout => normalizeWidgetLayout(layout).length === layout.length
export function placeWidget(layout, id, slot, span=1) {
  const current = layout.find(item=>item.id===id), moved = {...(current || {id,span}),slot}
  if (!valid(moved)) return null
  const others = layout.filter(item=>item.id!==id)
  const collisions = others.filter(item=>cells(item).some(cell=>cells(moved).includes(cell)))
  if (collisions.length && (!current || collisions.length!==1)) return null
  const next = layout.map(item=>item.id===id ? moved : collisions.includes(item) ? {...item,slot:current.slot} : item)
  if (!current) next.push(moved)
  return fits(next) ? next : null
}
export function resizeWidget(layout, id, span) {
  const next = layout.map(item=>item.id===id ? {...item,span} : item)
  return layout.some(item=>item.id===id) && fits(next) ? next : null
}
